import { render, staticRenderFns } from "./HarvesterServiceAddOnConfig.vue?vue&type=template&id=47f07ec5&"
import script from "./HarvesterServiceAddOnConfig.vue?vue&type=script&lang=js&"
export * from "./HarvesterServiceAddOnConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports